'use client'

import { motion } from 'framer-motion'
import { Plus } from 'lucide-react'
import { useNotebook } from '@/lib/notebook/core/store'

export default function AddSectionFab() {
  const locked = useNotebook((s) => s.locked)
  const planReadOnly = useNotebook((s) => s.planReadOnly)
  const openLauncher = useNotebook((s) => s.openLauncher)
  const promptPlanReadOnly = useNotebook((s) => s.promptPlanReadOnly)

  if (locked && !planReadOnly) return null

  const handleClick = () => {
    if (locked && planReadOnly) {
      promptPlanReadOnly('note')
      return
    }
    openLauncher()
  }

  return (
    <motion.button
      type="button"
      initial={{ opacity: 0, scale: 0.88, y: 10 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      whileHover={{ scale: locked ? 1 : 1.05, y: locked ? 0 : -3 }}
      whileTap={{ scale: locked ? 1 : 0.96 }}
      transition={{ type: 'spring', stiffness: 380, damping: 26 }}
      onClick={handleClick}
      className={`nb-add-section-fab${locked ? ' nb-add-section-fab--preserved' : ''}`}
      aria-label="Add section"
    >
      <Plus size={18} strokeWidth={2.5} />
    </motion.button>
  )
}
